import { IEntity, EntityStringId, Entity, IEntityType } from 'app/types/entity';
import vmClient from 'app/services/vmClient';
import { CopyrightLicense, CopyrightLicenseMarshaller } from 'app/constants/enums/CopyrightLicense';
import { BibliographyType, BibliographyTypeMarshaller } from 'app/constants/enums/BibliographyType';
import { LicensePartner, LicensePartnerMarshaller } from 'app/constants/enums/LicensePartner';
import { ALL_TRANSLATIONS } from 'app/constants/schemas/translations';
import { BibliographyTranslations } from 'app/constants/schemas/Bibliography';

export interface ILocalBibliography extends IEntity {
  attributes: {
    id: EntityStringId;
    type: BibliographyType;
    title: string | null;
    authors: string[] | null;
    publisher: string | null;
    url: string | null;
    copyrightLicense: CopyrightLicense;
    licensePartner: LicensePartner | null;
  };
}

export type LocalBibliography = Entity<ILocalBibliography>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocalBibliography: IEntityType<ILocalBibliography> = vmClient.defineClass({
  typeName: 'LocalBibliography',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: {
    type: {
      type: BibliographyType,
      marshaller: BibliographyTypeMarshaller,
      notNull: true,
    },
    title: 'string',
    authors: {
      type: 'string',
      collection: true,
    },
    publisher: 'string',
    url: 'string',
    copyrightLicense: {
      type: CopyrightLicense,
      marshaller: CopyrightLicenseMarshaller,
      notNull: true,
    },
    licensePartner: {
      type: LicensePartner,
      marshaller: LicensePartnerMarshaller,
    },
  },
  associations: {},
});

ALL_TRANSLATIONS.set(LocalBibliography, BibliographyTranslations);
